module.exports = __webpack_public_path__ + "static/media/customers_example.19ddc9f9.csv";